import Vue from 'vue'
import vClickOutside from 'v-click-outside'
import VueTouchEvents from 'vue2-touch-events'
import VueYoutube from 'vue-youtube'
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)
Vue.use(VueYoutube)
Vue.use(vClickOutside)
Vue.use(VueTouchEvents)

Vue.directive('intersect', {
  bind (el, binding, vnode) {
    const intersectionObserver = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        vnode.data.on['intersect-enter']()
      } else {
        vnode.data.on['intersect-leave']()
      }
    })
    intersectionObserver.observe(el)
  }
})

Vue.directive('analytics-module', {
  bind (el, binding) {
    const {
      value: { id = '', position = '', name = '' }
    } = binding || { value: {} }
    const positionString = position.toString()
    if (id) el.setAttribute('data-module-id', id)
    if (positionString) el.setAttribute('data-module-position', position)
    if (name) el.setAttribute('data-module-name', name)
  }
})

const analyticsItem = (el, binding) => {
  const {
    value: { id = '', type = '', position = '', name = '' }
  } = binding || { value: {} }
  if (id) el.setAttribute('data-item-id', id)
  if (type) el.setAttribute('data-item-type', type)
  if (position) el.setAttribute('data-item-position', position)
  if (name) el.setAttribute('data-item-name', name)
}

Vue.directive('analytics-item', {
  bind (el, binding) {
    analyticsItem(el, binding)
  },

  update (el, binding) {
    analyticsItem(el, binding)
  }
})
